import AppLayout from '@/layout/AppLayout.vue'

// import Trade from '@/view/trade/Trade.vue'
const Trade = () => import('@/view/trade/Trade.vue')
const CoinStockTrade = () => import('@/view/trade/CoinStockTrade.vue')
const GridLayout = () => import('@/view/trade/GridLayout.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/trade',
        props: route => ({ symbol: route.query.symbol }),
        component: Trade,
        meta: { key: 'trade' },
      },
      {
        path: '/coinStockTrade',
        props: route => ({ symbol: route.query.symbol }),
        component: CoinStockTrade,
        meta: { key: 'CoinStockTrade' },
      },
      {
        path: '/gridLayout',
        component: GridLayout,
      },
    ]
  },
]
const components = {}

export default {
  routes,
  components,
}
